import { Typography, withStyles, Tooltip, Avatar, Grid, Theme, WithStyles, createStyles } from '@material-ui/core';
import React from 'react';
import PersonAdd from '@material-ui/icons/PersonAdd';
import { withLocale } from 'hocs/withLocale';
import moment from 'moment';
import { CalendarEvent } from '../../../types';

interface PublicClassEventCellViewProps extends WithStyles<typeof styles> {
  event: CalendarEvent;
  classes: any;
  studio: any; // You might want to define a more specific type for studio
  onClick: (event: CalendarEvent, e: React.MouseEvent<HTMLDivElement>) => void;
  locale?: string; // From withLocale HOC
  t?: (key: string) => string; // From withLocale HOC
}

// Define styles
const styles = (theme: Theme) =>
  createStyles({
    root: {
      flex: 1,
      cursor: 'pointer',
    },
    time: {
      fontWeight: 900,
    },
    classTime: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '9px',
      },
      fontWeight: 900,
    },
    signUp: {
      position: 'absolute',
      top: 0,
      right: 0,
      [theme.breakpoints.down('sm')]: {
        fontSize: '9px',
      },
      fontWeight: 900,
    },
    classTitle: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '9px',
      },
    },
  });

// The component
class PublicClassEventCell extends React.Component<PublicClassEventCellViewProps> {
  render = () => {
    const { onClick, classes, event, studio } = this.props;
    const classInfo = event.classInfo;
    const eventObject = classInfo || event;
    const limit = eventObject ? eventObject.limit : null;
    const start = moment.utc(event.start);
    const end = moment.utc(start).add(eventObject.duration, 'minute').startOf('minute');

    let registrationExpired = event.noSignUp;
    let sportsLeft: number | undefined;

    if (classInfo && !classInfo.private && eventObject.allowSelfSignUp) {
      if (limit) {
        sportsLeft = limit - event.registeredCount;
        if (sportsLeft < 1) {
          registrationExpired = true;
        }
      }
    } else {
      registrationExpired = true;
    }

    return (
      <div
        onClick={(e) => onClick(event, e)}
        className={classes.root}
        style={{
          borderLeft: `4px solid ${event.room ? event.room.color : 'transparent'}`,
          backgroundColor: event.color,
        }}
      >
        {!registrationExpired && <PersonAdd className={classes.signUp} />}
        <Grid justify="space-between" container>
          <Grid item xs={12}>
            <Typography className={classes.classTime}>{start.format('HH:mm')}</Typography>
          </Grid>
          <Grid item xs={12}>
            {event.showTitle && (
              <Typography className={classes.classTitle} noWrap variant="caption">
                {event.title}
              </Typography>
            )}
            {!event.showTitle && (
              <Typography className={classes.classTitle} noWrap variant="caption">
                {event.billingTag}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            {event.teachers &&
              event.teachers.map((teacher) => {
                return (
                  <Tooltip
                    key={teacher.name}
                    className={classes.tooltip}
                    title={teacher.name}
                    aria-label={teacher.name}
                  >
                    <Avatar alt={teacher.name} src={teacher.avatar} sizes="small" style={{ width: 30, height: 30 }} />
                  </Tooltip>
                );
              })}
          </Grid>
        </Grid>
      </div>
    );
  };
}

export const PublicClassEventCellView = withLocale(withStyles(styles)(PublicClassEventCell));
